import { render, staticRenderFns } from "./ProductsHead.vue?vue&type=template&id=7c5feb7a&scoped=true"
import script from "./ProductsHead.vue?vue&type=script&lang=js"
export * from "./ProductsHead.vue?vue&type=script&lang=js"
import style0 from "./ProductsHead.vue?vue&type=style&index=0&id=7c5feb7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5feb7a",
  null
  
)

export default component.exports